(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("c-language-switcher")) {
  customElements.define(
    "c-language-switcher",
    class LanguageSwitcher extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.switcherList = this.querySelector(".js-language-switcher__list");
      }

      connectedCallback() {
        this.switcherList.addEventListener("change", this.handleSwitch);
        this.form.addEventListener("submit", this.handleFormSubmit);
      }

      disconnectedCallback() {
        this.switcherList.removeEventListener("change", this.handleSwitch);
        this.form.removeEventListener("submit", this.handleFormSubmit);
      }

      handleSwitch = (event) => {
        const submitEvent = new Event("submit", {
          bubbles: true,
          cancelable: true,
        });

        this.form.dispatchEvent(submitEvent);
      };

      handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.formSubmit();
      };

      formSubmit = () => {
        this.form.removeEventListener("submit", this.handleFormSubmit);

        this.form.submit();
      };
    }
  );
}

},{}]},{},[1])

